import React from 'react';
import { Link } from 'react-router-dom'

const About = () => {
    return (
        <div>
             <Link to="/" className="home-button">Home</Link> {/* Home button */}
            <h1>About</h1>
        </div>
    );
};

export default About;
